(function() {
    'use strict';

    angular.module('app',[]).config(function($httpProvider) {
        var csrfMeta = document.querySelector('meta[name="csrf-token"]');
        $httpProvider.defaults.headers.post['X-CSRF-Token'] = csrfMeta ? csrfMeta.getAttribute('content') : '';
        $httpProvider.defaults.timeout = 30000;
    }).config(["$interpolateProvider",function($interpolateProvider){
        $interpolateProvider.startSymbol("[[");
        $interpolateProvider.endSymbol("]]");
    }]);
})();
